import { SearchParameters } from '../context/actions/searchActions'
import { CategoriaNeumatico, NeumaticoCAEPrice } from '../types/Neumatico'
import { apiCall } from './api'
import { Promocion as PromocionCesta } from '../context/reducers/cestaReducer'
import { Promocion } from '../components/promotionBanner/PromotionBanner'
import { ConsumoLevels, LLuviaLevels, RuidoLevels } from '../types/Ecolabel'
import { Producto } from '../../shared/catalogo/producto/producto'
import { UserState } from '../context/reducers/userReducer'

const baseUrl = `${process.env.GATSBY_API_URL}`

export interface NeumaticoResult extends Producto {
  allseason: boolean
  ancho: number
  categoria: CategoriaNeumatico | 'Premium' | 'Quality' | 'Budget'
  consumo: ConsumoLevels
  cv: string
  decibelios: number
  descuento: number
  ecotasa: number
  ic: number
  id: string
  invierno: boolean
  llanta: number
  estructura: string
  lluvia: LLuviaLevels
  logo: string
  modelo: string
  nivel_ruido: RuidoLevels
  nombre_producto_es: string
  precio: number
  precioSinPromo: number
  promo: string
  promocion?: Promocion
  promocionCesta: PromocionCesta
  precioConEcotasa: number
  puntuacion: number
  runflat: boolean
  serie: number
  sku: string
  tipo_iva: number
  urlImagen: string
  verano: boolean
  equivalente?: string
  vehiculo: string | null
  descripcion_es: string
  descripcion_ca: string
  descripcion_pt: string
  eprel: string
  id_site_producto: string
  url_publica: boolean
  modelo_slug: string
  reforzada: string
  protector: boolean
  m_s: boolean
  tipo_antipinchazo: string
  especificacion_adicional: string
  marcaje: string
  cae?: NeumaticoCAEPrice
  pmsf: boolean
}

export interface SearchResults {
  neumaticos: NeumaticoResult[]
  pages: number
  total: number
  token: string | null
}

export function searchNeumaticos(
  query: SearchParameters
): Promise<SearchResults> {
  return apiCall(`${baseUrl}/neumaticos/selector`, {
    method: 'POST',
    body: JSON.stringify(query),
  })
}

export interface NavisionSearch {
  tipovehiculo: number
  ancho: number
  serie: number
  llanta: number
  ic: number
  cv: string
  runflat: boolean
  invierno: boolean
  allseason: boolean
  cantidad?: number
  marca?: number
  email: string
  phone: string
  zipcode: string
  origen: string
  device: 'MOBILE' | 'TABLET' | 'DESKTOP'
}

export function searchNavisionNeumaticos(
  data: NavisionSearch,
  userInfo: UserState
): Promise<{
  total: number
  neumaticos: NeumaticoResult[]
  priorityMarca: number | null
  token: string | null
}> {
  const navisionData = {
    ...data,
    useragent: navigator.userAgent,
  }
  return apiCall(`${process.env.GATSBY_API_URL}/neumaticos/selector/ws`, {
    method: 'POST',
    body: JSON.stringify({ ...navisionData, userInfo }),
  })
}
